import { createContext, useContext } from "react"

import { type BrandId } from "@forento/core/models/brand"

import forentoLogo from "~/assets/logos/forento.svg"

export type Brand = {
	id: BrandId
	name: string
	legalName: string
	logoUrl: string
	primaryColor: string
}

export const brands: Record<BrandId, Brand> = {
	forento: {
		id: "forento",
		name: "Forento",
		legalName: "Forento AB",
		logoUrl: forentoLogo,
		primaryColor: "#5120DD",
	},
}

const BrandContext = createContext<Brand>(brands.forento)

export const useBrand = () => useContext(BrandContext)

export default BrandContext
